<template>
    <div id="app">
        <NavBar v-if="user" />
        <div class="router-view">
            <router-view></router-view>
        </div>

        <!--        Modals       -->

        <div class="modal-background" v-if="hasModal"></div>

    </div>
</template>

<script>
    import NavBar from '@/components/navbar/NavBar';
    import {mapGetters} from 'vuex';

    export default {
        name: 'App',
        components: {
            NavBar
        },
        created() {
          this.$store.dispatch('fetchUser');
        },
        computed: mapGetters(['hasModal', 'user'])
    }
</script>

<style>
    @import 'css/main/app.css';
    @import 'css/main/colors.css';
    @import 'css/main/scrollbar.css';

    * {
        padding: 0;
        margin: 0;
    }

    body {
        margin: 0;
        padding: 0;
        font-family: Arial, Helvetica, sans-serif;
    }

    a {
        text-decoration: none;
    }

    #app {
        height: 100%;
    }

    .router-view {
        margin-left: 200px;
        margin-right: 50px;
        display: block;
        height: 100%;
        text-align: center;
    }

    .fa-spin {
      -webkit-animation: fa-spin 0.9s infinite linear !important;
      animation: fa-spin 0.9s infinite linear !important;
    }
</style>
